import { render, staticRenderFns } from "./NewSignature.vue?vue&type=template&id=450db8bc&scoped=true&"
import script from "./NewSignature.vue?vue&type=script&lang=js&"
export * from "./NewSignature.vue?vue&type=script&lang=js&"
import style0 from "./NewSignature.vue?vue&type=style&index=0&id=450db8bc&lang=scss&scoped=true&"
import style1 from "./NewSignature.vue?vue&type=style&index=1&id=450db8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450db8bc",
  null
  
)

export default component.exports